<div class="container-fluid p-4" justify-content-center *ngIf="documentData">
    <div class="row justify-content-center ">
        <div class="col-8">
            <div class="container-fluid bg-white rounded shadow p-3 ">

                <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center gap-3">

                        <button type="button" class="btn btn-light border rounded-circle"
                            style="width:38px;height:38px;" (click)="exitDoc()">
                            <i class="mdi mdi-arrow-left"></i>
                        </button>
                        <div class="d-flex flex-column">
                            <div class="fs-5 fw-bold">
                                {{ documentData?.title ? documentData?.title : 'PDF Viewer' }}
                            </div>
                            <small class="text-muted">
                                {{ documentData?.description ? documentData?.description : ''}}
                            </small>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end align-items-center gap-2">

                        <span *ngIf="documentData?.allSignersPositions?.length"
                            class="badge bg-primary-subtle text-primary fs-6 px-3 py-2">
                            Total Signers: {{ documentData?.allSignersPositions?.length }}
                        </span>

                    </div>

                </div>

                <!-- PDF Viewer -->
                <div id="viewer" class="viewer">
                    <div id="loading" class="text-muted">Loading PDF…</div>
                </div>


            </div>
        </div>
    </div>

</div>
<div class="container" *ngIf="false">
    <div class="card m-0">
        <div class="row">
            <div class="col-6">
                <div class="p-3">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                        <div class="d-flex align-items-center gap-3">

                            <button type="button" class="btn btn-light border rounded-circle"
                                style="width:38px;height:38px;" (click)="exitDoc()">
                                <i class="mdi mdi-arrow-left"></i>
                            </button>
                            <div class="d-flex flex-column">
                                <div class="fs-5 fw-bold d-flex align-items-center gap-2">
                                    {{ documentData?.title || 'PDF Viewer' }}

                                    <span class="badge bg-success-subtle text-success">
                                        JSON
                                    </span>
                                </div>
                                <small class="text-muted">
                                    {{ documentData?.description ? documentData?.description : ''}}
                                </small>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end align-items-center gap-2">

                            <span *ngIf="documentData?.allSignersPositions?.length"
                                class="badge bg-primary-subtle text-primary fs-6 px-3 py-2">
                                Total Signers: {{ documentData?.allSignersPositions?.length }}
                            </span>

                        </div>

                    </div>
                    <div>
                        <div class="position-relative">
                            <i class="mdi mdi-content-copy copy-icon" title="Copy JSON" (click)="copySignersJson()"></i>
                            <pre class="output mb-0">
{{ formattedSignersJson }}
    </pre>
                            <span *ngIf="copySuccess" class="copy-success">
                                Copied!
                            </span>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="container-fluid bg-white rounded shadow p-3">

                    <!-- <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center gap-3">

                        <button type="button" class="btn btn-light border rounded-circle"
                            style="width:38px;height:38px;" (click)="exitDoc()">
                            <i class="mdi mdi-arrow-left"></i>
                        </button>
                        <div class="d-flex flex-column">
                            <div class="fs-5 fw-bold">
                                {{ documentData?.title ? documentData?.title : 'PDF Viewer' }}
                            </div>
                            <small class="text-muted">
                                {{ documentData?.description ? documentData?.description : ''}}
                            </small>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end align-items-center gap-2">

                        <button (click)="getJson()"
                            class="btn btn-outline-success btn-sm d-flex align-items-center gap-1">
                            {{ showJSON ? 'Hide JSON' : 'Get JSON' }}
                        </button>

                        <span *ngIf="documentData?.allSignersPositions?.length"
                            class="badge bg-primary-subtle text-primary fs-6 px-3 py-2">
                            Total Signers: {{ documentData?.allSignersPositions?.length }}
                        </span>

                    </div>

                </div> -->

                    <div id="viewer" class="viewer">
                        <div id="loading" class="text-muted">Loading PDF…</div>
                    </div>


                </div>
            </div>

        </div>
    </div>

</div>